export default "__VITE_ASSET__DNM8m6GW__"